import { BaseCard, CardBody, Css, formatDate, Palette } from "@homebound/beam";
import { Fragment } from "react";
import { PLAN_FALLBACK_IMG } from "src/routes/libraries/plan-package/takeoffs/utils";
import { formatList } from "src/utils";
import { ApplyConfigurationCard_CheckoutConfigFragment } from "./ApplyConfigurationCard.generated";

type ApplyConfigurationCardProps = {
  checkoutConfig: ApplyConfigurationCard_CheckoutConfigFragment;
  onClick?: () => void;
  onRemove?: () => void;
};

/** Displays a ready plan configuration's cover photo, plan and design selections. */
export function ApplyConfigurationCard(props: ApplyConfigurationCardProps) {
  const { checkoutConfig, onClick, onRemove } = props;
  const { updatedAt, config } = checkoutConfig;
  const { name, productOffering, aggregateVersion, exteriorOptionNames, interiorOptionNames } = config;
  const fields = [
    { label: "Plan", value: productOffering?.name },
    { label: "Exterior", value: formatList(exteriorOptionNames) },
    { label: "Interior", value: formatList(interiorOptionNames) },
    { label: "Version", value: aggregateVersion?.displayVersion ?? "-" },
    { label: "Updated", value: formatDate(updatedAt.toPlainDate(), "shortDate") },
  ];
  return (
    <BaseCard
      imgSrc={productOffering?.coverAsset?.previewUrl ?? PLAN_FALLBACK_IMG}
      imgAlt={productOffering?.name ?? ""}
      onClick={onClick}
      action={onRemove ? { icon: "trash", label: "Replace", onClick: onRemove, bgColor: Palette.White } : undefined}
    >
      <CardBody title={name}>
        <ConfigurationFields fields={fields} />
      </CardBody>
    </BaseCard>
  );
}

function ConfigurationFields(props: { fields: { label: string; value: string | undefined }[] }) {
  const { fields } = props;
  return (
    <dl css={Css.dg.gtc("1fr 1fr").rg1.cg2.mb0.mta.$}>
      {fields.map((field) => (
        <Fragment key={field.label}>
          <dt css={Css.smSb.$}>{field.label}</dt>
          <dd css={Css.sm.m0.$}>{field.value ?? "-"}</dd>
        </Fragment>
      ))}
    </dl>
  );
}
